<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <img
            :src="`/img/models/${categoryInfo.slug}/${subcategoryInfo.slug}.jpg`"
            :alt="categoryInfo.name"
            :title="categoryInfo.name"
            :data-fallback="`https://placehold.co/600?text=${categoryInfo.name}`"
            onerror="this.onerror=null;this.src=this.getAttribute('data-fallback')"
          />
        </div>
        <div class="col-md-6">
          <RepairServiceForm
            :categoryInfo="categoryInfo"
            :subcategoryInfo="subcategoryInfo"
            :services="subCategoryServices"
          />
        </div>
      </div>
      <div class="row mt-20">
        <div class="container">
          <div class="col-md-12">
            <div v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RepairPageMixin from '@/components/repair/RepairPageMixin'
import RepairServiceForm from '@/components/repair/RepairServiceForm'

export default {
  name: 'RepairServiceSubcategory',
  mixins: [RepairPageMixin],
  components: { RepairServiceForm },
  computed: {
    subCategoryServices() {
      return this.repair.services.filter(
        ({ subcategory }) => subcategory === this.subcategoryInfo.name
      )
    },
    content() {
      if (!this.subcategoryInfo?.name) {
        return ''
      }
      const obj = this.repair?.subcategoriesMapping?.[this.subcategoryInfo.name]

      if (!obj) {
        return ''
      }

      return obj[`description_${this.$i18n.locale}`]
    },
  },
}
</script>

<style>
</style>
